import ManagerList from './ManagerList'
import ManagerCreate from './ManagerCreate'
import ManagerWelcome from './ManagerWelcome'

export default {
  ManagerList,
  ManagerCreate,
  ManagerWelcome
}
